import PropTypes from 'prop-types';
import filter from 'lodash/filter';
import get from 'lodash/get';
import find from 'lodash/find';
import flatMap from 'lodash/flatMap';

export const DATE = 'date';
export const RELEVANCY = 'relevancy';
export const PRICE = 'price';
export const TENANCY = 'tenancy.numberOfTenants';
export const NET_INCOME = 'tenancy.netIncome';
export const CALCULATED_YIELD = 'calculatedYield';

export const RELEVANCY_SORT = {
  name: RELEVANCY,
  direction: 'asc',
  displayText: 'Most Relevant',
  value: `${RELEVANCY}-asc`,
  omniturePage: 'most relevant',
  omnitureClick: 'most-relevant',
};

export const DATE_DESC_SORT = {
  name: DATE,
  direction: 'desc',
  displayText: 'Date (Newest - Oldest)',
  value: `${DATE}-desc`,
  bff: 'listing-date-newest-first',
  omniturePage: 'date (newest - oldest)',
  omnitureClick: 'date:desc',
};

export const DATE_ASC_SORT = {
  name: DATE,
  direction: 'asc',
  displayText: 'Date (Oldest - Newest)',
  value: `${DATE}-asc`,
  bff: 'listing-date-oldest-first',
  omniturePage: 'date (oldest - newest)',
  omnitureClick: 'date:asc',
};

export const PRICE_DESC_SORT = {
  name: PRICE,
  direction: 'desc',
  displayText: 'High - Low',
  longDisplayText: 'Price (High - Low)',
  value: `${PRICE}-desc`,
  bff: 'price-descending',
  omniturePage: 'price (high - low)',
  omnitureClick: 'price:desc',
};

export const PRICE_ASC_SORT = {
  name: PRICE,
  direction: 'asc',
  displayText: 'Low - High',
  longDisplayText: 'Price (Low - High)',
  value: `${PRICE}-asc`,
  bff: 'price-ascending',
  omniturePage: 'price (low - high)',
  omnitureClick: 'price:asc',
};

export const TENANCY_DESC_SORT = {
  name: TENANCY,
  direction: 'desc',
  displayText: 'Tenants (High - Low)',
  value: `${TENANCY}-desc`,
  omniturePage: 'tenants (high - low)',
  omnitureClick: 'tenants:desc',
};

export const TENANCY_ASC_SORT = {
  name: TENANCY,
  direction: 'asc',
  displayText: 'Tenants (Low - High)',
  value: `${TENANCY}-asc`,
  omniturePage: 'tenants (low - high)',
  omnitureClick: 'tenants:asc',
};

export const NET_INCOME_DESC_SORT = {
  name: NET_INCOME,
  direction: 'desc',
  displayText: 'High - Low',
  longDisplayText: 'Income (High - Low)',
  value: `${NET_INCOME}-desc`,
  omniturePage: 'income (high - low)',
  omnitureClick: 'income:desc',
};

export const NET_INCOME_ASC_SORT = {
  name: NET_INCOME,
  direction: 'asc',
  displayText: 'Low - High',
  longDisplayText: 'Income (Low - High)',
  value: `${NET_INCOME}-asc`,
  omniturePage: 'income (low - high)',
  omnitureClick: 'income:asc',
};

export const CALCULATED_YIELD_DESC_SORT = {
  name: CALCULATED_YIELD,
  direction: 'desc',
  displayText: 'High - Low',
  longDisplayText: 'Yield (High - Low)',
  value: `${CALCULATED_YIELD}-desc`,
  omniturePage: 'yield (high - low)',
  omnitureClick: 'yield:desc',
};

export const CALCULATED_YIELD_ASC_SORT = {
  name: CALCULATED_YIELD,
  direction: 'asc',
  displayText: 'Low - High',
  longDisplayText: 'Yield (Low - High)',
  value: `${CALCULATED_YIELD}-asc`,
  omniturePage: 'yield (low - high)',
  omnitureClick: 'yield:asc',
};

export const SORT_OPTIONS = [
  RELEVANCY_SORT,
  DATE_DESC_SORT,
  DATE_ASC_SORT,
  PRICE_DESC_SORT,
  PRICE_ASC_SORT,
  TENANCY_DESC_SORT,
  TENANCY_ASC_SORT,
  NET_INCOME_DESC_SORT,
  NET_INCOME_ASC_SORT,
  CALCULATED_YIELD_DESC_SORT,
  CALCULATED_YIELD_ASC_SORT,
];

const getSortOptionsByName = value => (
  filter(SORT_OPTIONS, option => value && get(option, 'name') === value)
);

export const getSortOptionByValue = value => (
  find(SORT_OPTIONS, option => value && get(option, 'value') === value)
);

export const filterSortOptions = sortOptions => (
  flatMap(sortOptions, optionName => getSortOptionsByName(optionName))
);

export const sortOptionPropTypes = {
  name: PropTypes.string.isRequired,
  direction: PropTypes.string.isRequired,
  displayText: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};
